// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"431":"7035ca7d","453":"0aaffc9c","580":"8f6091af"}[chunkId] + ".chunk.js";
};